export const mockDataDuplicates = {
  success: true,
  isCompleteSet: true,
  duplicates: [
    { photo: null, label: "user@test.com", duplicateID: 23441 },
    {
      photo: "//d6iyrqjd26xke.cloudfront.net/profileforest2/profile.jpg",
      label: "Mark Foster",
      duplicateID: 28722,
    },
    { photo: null, label: "Test User 3", duplicateID: 3847 },
    { photo: null, label: "Test User 4", duplicateID: 4434 },
    { photo: null, label: "Test User 4", duplicateID: 5943 },
    { photo: null, label: "Test User 5", duplicateID: 6948 },
    { photo: null, label: "Test User 5", duplicateID: 6949 },
    { photo: null, label: "Test User 5", duplicateID: 6950 },
    { photo: null, label: "Test User 5", duplicateID: 6951 },
    { photo: null, label: "Test User 5", duplicateID: 6952 },
    // { photo: null, label: "Test User 5", duplicateID: 6953 },
    // { photo: null, label: "Test User 5", duplicateID: 6954 },
    // { photo: null, label: "Test User 5", duplicateID: 6955 },
    // { photo: null, label: "Test User 5", duplicateID: 6956 },
    // { photo: null, label: "Test User 5", duplicateID: 6957 },
    // { photo: null, label: "Test User 5", duplicateID: 6958 },
  ],
};
